export default __webpack_public_path__ + "static/media/location.6515f42b.svg";